import type { FC } from 'react';
import { useNavigate } from 'react-router';
import { ownerContributorAndViewerIds } from 'src/components/form';
import { useHasPermissionQuery } from 'src/rbac/useHasPermission';

import { useInsertDocument } from '@/hooks/mutations';
import { policyDetailsUrl } from '@/utils/urls';

import DocumentForm from '../../forms/DocumentForm';
import type { DocumentFormFieldData } from '../../forms/documentSchema';

const Tab: FC = () => {
  const {
    hasPermission: canCreateDocument,
    loading: canCreateDocumentLoading,
  } = useHasPermissionQuery('insert:document');
  const navigate = useNavigate();
  const { insertDocument } = useInsertDocument();

  const onSave = async ({
    ancestorContributors: _1,
    Contributors,
    Owners,
    Viewers,
    linkedDocuments,
    attestationTimeLimit,
    attestationPromptText,
    attestationGroups,
    requireAttestationFromEveryone,
    departments,
    tags,
    ...data
  }: DocumentFormFieldData) => {
    const result = await insertDocument({
      ...data,
      ...ownerContributorAndViewerIds({ Contributors, Owners, Viewers }),
      LinkedDocumentIds: linkedDocuments.map(
        (linkedDocument) => linkedDocument.value
      ),
      CustomAttributeData: data.CustomAttributeData || undefined,
      attestation: {
        RequireGlobalAttestation: requireAttestationFromEveryone === 'true',
        AttestationTimeLimit: attestationTimeLimit,
        AttestationPromptText: attestationPromptText,
        AttestationGroupIds: attestationGroups.map((group) => group.value),
      },
      TagTypeIds: tags?.map((t) => t.TagTypeId) || [],
      DepartmentTypeIds: departments?.map((d) => d.DepartmentTypeId) || [],
    });
    if (result.insertChildDocument?.Id) {
      navigate(policyDetailsUrl(result.insertChildDocument.Id), {
        replace: true,
      });
    }

    return { savedId: result.insertChildDocument?.Id };
  };

  const onDismiss = (saved: boolean) => {
    if (!saved) {
      navigate(-1);
    }
  };

  return (
    <DocumentForm
      onDismiss={onDismiss}
      onSave={onSave}
      readOnly={!canCreateDocument || canCreateDocumentLoading}
    />
  );
};

export default Tab;
